var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_155_14483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 11H11V3H3V11ZM5 5H9V9H5V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 21H11V13H3V21ZM5 15H9V19H5V15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3V11H21V3H13ZM19 9H15V5H19V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 19H19V21H21V19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 13H13V15H15V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 15H15V17H17V15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 17H13V19H15V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 19H15V21H17V19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 17H17V19H19V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 13H17V15H19V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15H19V17H21V15Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_155_14483"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode);
export default __webpack_public_path__ + "static/media/qr_code.b6f4eae94b6be33e63d021d23473c6fe.svg";
export { ForwardRef as ReactComponent };